import cn from 'classnames';
import React from 'react';
import {
  BlueskyButton,
  FacebookButton,
  InstagramButton,
  LinkedInButton,
  SocialButtonProps,
  ThreadsButton,
  TikTokButton,
  TwitterButton,
  YouTubeButton,
} from 'components/SocialButton';
import { DESTINATION_PLATFORMS } from './constants';
import { DestinationPlatform } from './types';
import { block } from './utils';

type PlatformButtonProps = Pick<
  SocialButtonProps,
  'disabled' | 'onClick' | 'tooltip'
>;

const PLATFORM_BUTTONS: Partial<Record<
  DestinationPlatform,
  React.ComponentType<PlatformButtonProps>
>> = {
  youtube: YouTubeButton,
  instagram: InstagramButton,
  facebook: FacebookButton,
  tiktok: TikTokButton,
  linkedin: LinkedInButton,
  threads: ThreadsButton,
  twitter: TwitterButton,
  bluesky: BlueskyButton,
};

export type DisabledPlatformsMap = Partial<
  Record<DestinationPlatform, { tooltip: string }>
>;

export interface DestinationPlatformsContentsProps {
  className?: string;
  disabledPlatforms?: DisabledPlatformsMap;
  onPlatformSelection: (platform: DestinationPlatform) => void;
}

const DestinationPlatformsContents: React.FC<DestinationPlatformsContentsProps> = ({
  className,
  disabledPlatforms,
  onPlatformSelection,
}) => (
  <div className={cn(block('platforms-container'), className)}>
    {DESTINATION_PLATFORMS.map(platform => {
      const PlatformButton = PLATFORM_BUTTONS[platform];
      if (!PlatformButton) return null;

      const tooltip = disabledPlatforms?.[platform]?.tooltip;
      return (
        <PlatformButton
          key={platform}
          disabled={!!tooltip}
          tooltip={tooltip}
          onClick={() => onPlatformSelection(platform)}
        />
      );
    })}
  </div>
);

export default DestinationPlatformsContents;
